import React from "react";
import { useQuickSightIAM  } from "@/hooks/useIAMReports";

const QuickSightAwsIAMDashboard = () => {
  const { embedUrl } = useQuickSightIAM ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsIAMDashboard;
